import { AddressEncoding, getAddressEncoding, L1Types } from 'dex-app.cm';

import { isBtcLikeCurrency, isErc20Currency, isEvmCurrency, isTrc20Currency, isTronCurrency } from '@/utils';

import { ENV } from './env';
import { Currency } from './tokens';

export const ENCODING_MAP = {
  [AddressEncoding.Base58]: 'base58',
  [AddressEncoding.Bech32]: 'bech32',
  [AddressEncoding.Bech32m]: 'bech32m',
  [AddressEncoding.Hex]: 'hex',
} as const;

export function getPreset({ toCurrency, l1Recipient }: { l1Recipient: string; toCurrency: Currency }): number {
  switch (true) {
    case isEvmCurrency(toCurrency):
    case isErc20Currency(toCurrency):
    case isTronCurrency(toCurrency):
    case isTrc20Currency(toCurrency): {
      return Number(ENV[`VITE_PRESET_TO_${toCurrency.toUpperCase()}`]);
    }
    case isBtcLikeCurrency(toCurrency): {
      const encoding = getAddressEncoding(l1Recipient, L1Types.Btc);
      return Number(ENV[`VITE_PRESET_TO_${toCurrency.toUpperCase()}_${ENCODING_MAP[encoding].toUpperCase()}`]);
    }
    default:
      throw new Error(`Unmatched preset for currency ${toCurrency}`);
  }
}
